import { TernaryOption } from '@inversor-hub/types';

type TernaryOptionLabel = 'Sí' | 'No' | 'Otro';

export const labelToValue: Record<TernaryOptionLabel, TernaryOption> = {
  Sí: 'YES',
  No: 'NO',
  Otro: 'OTHER',
};

const valueToLabel: Record<TernaryOption, TernaryOptionLabel> = {
  YES: 'Sí',
  NO: 'No',
  OTHER: 'Otro',
};

export function getTernaryValue(label: string): TernaryOption {
  return labelToValue[label as TernaryOptionLabel] ?? '';
}

export function getTernaryLabel(value: string): TernaryOptionLabel {
  return valueToLabel[value as TernaryOption] || '';
}
